/**
 * Collection quick-add and other /cart/add calls post a variant id only.
 * The product-page Preorder button also sends a selling plan and a ship-date
 * property. This wraps fetch and adds those for variants Stoq already treats
 * as preorder (out of stock, one selling plan). In-stock sizes are left alone.
 * If anything here fails, the original add goes through unchanged.
 */
(function () {
  if (window.__kfPreorderQuickAddInstalled) return;
  window.__kfPreorderQuickAddInstalled = true;

  var previousFetch = window.fetch.bind(window);
  var SHOP_TIME_ZONE = "America/New_York";
  var variantCache = new Map();

  function isCartAddUrl(url) {
    if (!url) return false;
    try {
      var path = new URL(url, window.location.origin).pathname;
      return path === "/cart/add" || path === "/cart/add.js" || /\/cart\/add(\.js)?$/.test(path);
    } catch (e) {
      return String(url).indexOf("/cart/add") !== -1;
    }
  }

  function requestUrl(input) {
    if (typeof input === "string") return input;
    if (input && input.url) return input.url;
    return "";
  }

  function stoqConfig() {
    return window._RestockRocketConfig || window._StoqConfig || null;
  }

  function preorderIdSet() {
    var cfg = stoqConfig();
    var ids = cfg && cfg.cachedPreorderVariantIds && cfg.cachedPreorderVariantIds.preorder_variant_ids;
    if (!Array.isArray(ids) || ids.length === 0) return null;
    var set = new Set();
    ids.forEach(function (id) { set.add(String(id)); });
    return set;
  }

  function indexCardVariants() {
    var nodes = document.querySelectorAll('script[type="application/json"]');
    nodes.forEach(function (node) {
      var parsed;
      try {
        parsed = JSON.parse(node.textContent);
      } catch (e) {
        return;
      }
      if (!Array.isArray(parsed)) return;
      parsed.forEach(function (variant) {
        if (variant && variant.id != null && (variant.inventory_quantity != null || variant.selling_plan_allocations)) {
          variantCache.set(String(variant.id), variant);
        }
      });
    });
  }

  function variantIsComplete(variant) {
    return variant && variant.inventory_quantity != null && Array.isArray(variant.selling_plan_allocations);
  }

  function lookupVariant(id) {
    var key = String(id);
    var cached = variantCache.get(key);
    if (variantIsComplete(cached)) return Promise.resolve(cached);

    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 1500);
    return previousFetch("/variants/" + encodeURIComponent(key) + ".js", {
      credentials: "same-origin",
      signal: controller.signal
    }).then(function (response) {
      if (!response.ok) return cached || null;
      return response.json();
    }).then(function (variant) {
      if (variant && variant.id != null) variantCache.set(String(variant.id), variant);
      return variant || cached || null;
    }).catch(function () {
      return cached || null;
    }).finally(function () {
      clearTimeout(timer);
    });
  }

  function planIdForVariant(variant) {
    if (!variant) return null;
    var allocations = variant.selling_plan_allocations || [];
    if (allocations.length !== 1 || allocations[0].selling_plan_id == null) return null;

    var qty = Number(variant.inventory_quantity);
    if (!Number.isFinite(qty) || qty > 0) return null;

    var preorderIds = preorderIdSet();
    if (preorderIds && !preorderIds.has(String(variant.id))) return null;

    return String(allocations[0].selling_plan_id);
  }

  function findStoqPlan(planId) {
    var plans = (stoqConfig() && stoqConfig().sellingPlans) || [];
    for (var i = 0; i < plans.length; i++) {
      if (String(plans[i].shopify_selling_plan_id) === String(planId) && plans[i].enabled !== false) {
        return plans[i];
      }
    }
    return null;
  }

  function shipDateProperty(plan) {
    if (!plan) return null;
    var template = plan.custom_line_item_property_text;
    var raw = plan.delivery_exact_time || plan.delivery_at;
    if (!template || template.indexOf("{{ date }}") === -1 || !raw) return null;
    var date = new Date(raw);
    if (Number.isNaN(date.getTime())) return null;
    var formatted = new Intl.DateTimeFormat("en-US", {
      timeZone: SHOP_TIME_ZONE,
      month: "short",
      day: "numeric",
      year: "numeric"
    }).format(date);
    return {
      key: plan.preorder_button_text || plan.name || "Preorder",
      value: template.replace("{{ date }}", formatted)
    };
  }

  function lineItemsFromJson(data) {
    if (!data || typeof data !== "object") return [];
    if (Array.isArray(data.items)) return data.items.filter(function (item) { return item && typeof item === "object"; });
    if (data.id != null) return [data];
    return [];
  }

  function alreadyHasPlan(item) {
    return item && item.selling_plan != null && String(item.selling_plan) !== "";
  }

  function decorateJsonItem(item) {
    if (!item || item.id == null || alreadyHasPlan(item)) return Promise.resolve(false);
    return lookupVariant(item.id).then(function (variant) {
      var planId = planIdForVariant(variant);
      if (!planId) return false;
      item.selling_plan = planId;
      var property = shipDateProperty(findStoqPlan(planId));
      if (property) {
        item.properties = item.properties || {};
        if (!item.properties[property.key]) item.properties[property.key] = property.value;
      }
      return true;
    });
  }

  function decorateFormData(formData) {
    if (formData.get("selling_plan")) return Promise.resolve(false);
    var id = formData.get("id");
    if (!id) return Promise.resolve(false);
    return lookupVariant(id).then(function (variant) {
      var planId = planIdForVariant(variant);
      if (!planId) return false;
      formData.set("selling_plan", planId);
      var property = shipDateProperty(findStoqPlan(planId));
      if (property && !formData.get("properties[" + property.key + "]")) {
        formData.append("properties[" + property.key + "]", property.value);
      }
      return true;
    });
  }

  function maybeAttach(input, init) {
    var body = init && init.body;
    if (body instanceof FormData) {
      return decorateFormData(body).then(function () {
        return { input: input, init: init };
      });
    }
    if (body instanceof URLSearchParams) {
      var asForm = new FormData();
      body.forEach(function (value, key) { asForm.append(key, value); });
      return decorateFormData(asForm).then(function (changed) {
        if (!changed) return { input: input, init: init };
        var params = new URLSearchParams();
        asForm.forEach(function (value, key) { params.append(key, value); });
        return { input: input, init: Object.assign({}, init, { body: params }) };
      });
    }
    if (typeof body === "string") {
      var parsed;
      try {
        parsed = JSON.parse(body);
      } catch (e) {
        return Promise.resolve({ input: input, init: init });
      }
      var items = lineItemsFromJson(parsed);
      return items.reduce(function (chain, item) {
        return chain.then(function (any) {
          return decorateJsonItem(item).then(function (changed) { return any || changed; });
        });
      }, Promise.resolve(false)).then(function (any) {
        if (!any) return { input: input, init: init };
        return { input: input, init: Object.assign({}, init, { body: JSON.stringify(parsed) }) };
      });
    }
    return Promise.resolve({ input: input, init: init });
  }

  window.fetch = function (input, init) {
    if (!isCartAddUrl(requestUrl(input))) return previousFetch(input, init);
    indexCardVariants();
    return maybeAttach(input, init).then(function (next) {
      return previousFetch(next.input, next.init);
    }).catch(function () {
      return previousFetch(input, init);
    });
  };
})();
